import React from 'react';

export interface SubHeaderPropsInterface {
  leftWidget?: React.ComponentType | React.ReactNode;
  rightWidget?: React.ComponentType | React.ReactNode;
  className?: string;
  leftWidgetWidth?: string;
  rightWidgetWidth?: string;
  leftWidgetClassName?: string;
  rightWidgetClassName?: string;
  leftOverflowXClassName?: string;
  rightOverflowXClassName?: string;
}

export const SubHeader: React.FC<SubHeaderPropsInterface> = ({
  leftWidget: LeftWidget,
  rightWidget: RightWidget,
  className = '',
  leftWidgetClassName = '',
  rightWidgetClassName = '',
  leftWidgetWidth = '',
  rightWidgetWidth = '',
  leftOverflowXClassName = 'overflow-x-auto',
  rightOverflowXClassName = 'overflow-x-auto',
}) => {
  return (
    <div className={`flex flex-row justify-between ${className}`}>
      {LeftWidget && (
        <div
          className={`${
            RightWidget ? leftWidgetWidth : 'max-w-full'
          } flex items-center ${leftOverflowXClassName} ${leftWidgetClassName}`}
        >
          {typeof LeftWidget === 'function' ? <LeftWidget /> : LeftWidget}
        </div>
      )}
      {RightWidget && (
        <div
          className={`${
            LeftWidget ? rightWidgetWidth : 'max-w-full'
          } flex items-center ${rightOverflowXClassName} ml-auto ${rightWidgetClassName}`}
        >
          {typeof RightWidget === 'function' ? <RightWidget /> : RightWidget}
        </div>
      )}
    </div>
  );
};

export default SubHeader;
